import React, { useState } from "react";
import cloudStore from "../store/CloudStore";
import { Button, FormControlLabel, Grid, MenuItem, Paper, Select, Switch, Typography } from "@material-ui/core";
import withIntl from "../utils/withIntl";
import { _post } from "../Api";
import { toast } from "react-toastify";
import { setMerchant } from "../store/CloudActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import EditTextField from "../components/EditArticle/EditTextField";
import SelectArticles from "../components/Forms/SelectArticles";
import AuthorizationWrapper from "../components/AuthorizationWrapper";

function Takeawaycom(props) {
  const [takeawayMerchant, setTakeawayMerchant] = useState(cloudStore.merchant.takeaway_merchant);
  const [waitingForApiCall, setWaitingForApiCall] = useState(false);

  if (waitingForApiCall) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  if (takeawayMerchant == null) {
    return (
      <Paper style={{ padding: 8 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant={"h6"}>Takeaway.com</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ fontStyle: "italic" }}>Takeaway.com / Thuisbezorgd.nl koppeling</Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant={"contained"}
              color={"primary"}
              onClick={() => {
                updateTakeawaycom({ merchant_id: cloudStore.merchant.id }).then((takeawayMerchant) => {
                  takeawayMerchant.merchant_id = cloudStore.merchant.id;
                  setTakeawayMerchant(takeawayMerchant);
                });
              }}
            >
              Create connection
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  }

  return (
    <Paper style={{ padding: 8 }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant={"h6"}>Takeaway.com</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontStyle: "italic" }}>Takeaway.com / Thuisbezorgd.nl koppeling</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={{ fontStyle: "italic" }}>Disabled: </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={{ fontStyle: "italic" }}>{!takeawayMerchant.active ? "Yes" : "No"}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={{ fontStyle: "italic" }}>Logged in:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={{ fontStyle: "italic" }}>{takeawayMerchant.logged_in ? "Yes" : "No"}</Typography>
        </Grid>

        <AuthorizationWrapper
          permission={"takeawaycom.api_key"}
          child={
            <>
              <Grid item xs={6}>
                Api Key:
              </Grid>
              <Grid item xs={6}>
                <Select
                  value={takeawayMerchant.takeaway_api_id}
                  onChange={(e) => {
                    updateTakeawaycom({
                      merchant_id: takeawayMerchant.merchant_id,
                      takeaway_api_id: e.target.value,
                    }).then((takeawayMerchant) => {
                      setTakeawayMerchant(takeawayMerchant);
                    });
                  }}
                >
                  <MenuItem value={2}>MynOber</MenuItem>
                  <MenuItem value={1}>I Love Sushi</MenuItem>
                </Select>
              </Grid>
            </>
          }
        />
        <AuthorizationWrapper
          permission={"takeawaycom.ext_id"}
          child={
            <>
              <Grid item xs={6}>
                Takeaway.com Restaurant ID
              </Grid>
              <Grid item xs={6}>
                <EditTextField
                  value={takeawayMerchant.ext_id ?? ""}
                  onBlur={(value, setBeginValue) => {
                    updateTakeawaycom({
                      merchant_id: takeawayMerchant.merchant_id,
                      ext_id: value,
                    }).then((merchant) => {
                      setTakeawayMerchant(merchant);
                      setBeginValue(value);
                    });
                  }}
                />
              </Grid>
            </>
          }
        />

        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Switch
                color={"primary"}
                checked={!takeawayMerchant.active}
                onChange={(e) => {
                  updateTakeawaycom({ merchant_id: takeawayMerchant.merchant_id, active: !e.target.checked }).then(
                    (takeawayMerchant) => {
                      setTakeawayMerchant(takeawayMerchant);
                    }
                  );
                }}
              />
            }
            label={"Disabled"}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Switch
                color={"primary"}
                checked={takeawayMerchant.auto_confirm_orders}
                onChange={(e) => {
                  updateTakeawaycom({
                    merchant_id: takeawayMerchant.merchant_id,
                    auto_confirm_orders: e.target.checked,
                  }).then((takeawayMerchant) => {
                    setTakeawayMerchant(takeawayMerchant);
                  });
                }}
              />
            }
            label={"Automatically confirm orders"}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Switch
                color={"primary"}
                checked={takeawayMerchant.auto_close_orders}
                onChange={(e) => {
                  updateTakeawaycom({
                    merchant_id: takeawayMerchant.merchant_id,
                    auto_close_orders: e.target.checked,
                  }).then((takeawayMerchant) => {
                    setTakeawayMerchant(takeawayMerchant);
                  });
                }}
              />
            }
            label={"Automatically close orders"}
          />
        </Grid>

        <Grid item xs={6}>
          Payment method prefix
        </Grid>
        <Grid item xs={6}>
          <EditTextField
            value={takeawayMerchant.payment_method_prefix ?? ""}
            onBlur={(value, setBeginValue) => {
              updateTakeawaycom({
                merchant_id: takeawayMerchant.merchant_id,
                payment_method_prefix: value === "" ? null : value,
              }).then((merchant) => {
                setTakeawayMerchant(merchant);
                setBeginValue(value === "" ? null : value);
              });
            }}
          />
        </Grid>
        <Grid item xs={6}>
          Table id prefix
        </Grid>
        <Grid item xs={6}>
          <EditTextField
            value={takeawayMerchant.table_id_prefix ?? ""}
            onBlur={(value, setBeginValue) => {
              updateTakeawaycom({
                merchant_id: takeawayMerchant.merchant_id,
                table_id_prefix: value === "" ? null : value,
              }).then((merchant) => {
                setTakeawayMerchant(merchant);
                setBeginValue(value === "" ? null : value);
              });
            }}
          />
        </Grid>
        <Grid item xs={6}>
          Unknown article plu
        </Grid>
        <Grid item xs={6} container>
          <SelectArticles
            filteredOutArticles={[]}
            handleOnSelect={(article) => {
              updateTakeawaycom({
                merchant_id: takeawayMerchant.merchant_id,
                unknown_article_plu: article.plu,
              }).then((merchant) => {
                setTakeawayMerchant(merchant);
              });
            }}
            label={props.intl.formatMessage({ id: "select_article" })}
            value={takeawayMerchant.unknown_article_plu}
            helperText={props.intl.formatMessage({ id: "select_article" })}
          />
          {takeawayMerchant.unknown_article_plu != null && (
            <Button
              variant={"outlined"}
              onClick={() => {
                updateTakeawaycom({
                  merchant_id: takeawayMerchant.merchant_id,
                  unknown_article_plu: null,
                }).then((merchant) => {
                  setTakeawayMerchant(merchant);
                });
              }}
            >
              Remove plu
            </Button>
          )}
        </Grid>
        <Grid item xs={6}>
          Default vat for unlinked article (eg. 0.09 or 0.21 for respectively 9% or 21%)
        </Grid>
        <Grid item xs={6}>
          <EditTextField
            value={takeawayMerchant.default_vat_articles ?? ""}
            onBlur={(value, setBeginValue) => {
              updateTakeawaycom({
                merchant_id: takeawayMerchant.merchant_id,
                default_vat_articles: value === "" ? null : value,
              }).then((merchant) => {
                setTakeawayMerchant(merchant);
                setBeginValue(value === "" ? null : value);
              });
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

function updateTakeawaycom(takeawayMerchant) {
  let data = { ...takeawayMerchant };

  return _post(`/nova/v2/takeawaycom_merchants/update`, [data])
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      let updatedMerchant = { ...cloudStore.merchant };
      updatedMerchant.takeaway_merchant = res.data[0];

      setMerchant(updatedMerchant);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data[0]);
    });
}

export default withIntl(Takeawaycom);
